import {
  ThemeAllProps,
  ThemeDirectProps,
  ThemeFlexDirectionProps,
  ThemeFlexProps,
  ThemeOverflowProps,
  ThemePointerEventsProps,
  ThemePositionProps,
  ThemeShadowProps,
  ThemeVisibilityProps,
} from '../../types';

type Categories =
  | 'shadow'
  | 'flexDirection'
  | 'flex'
  | 'position'
  | 'visibility'
  | 'pointerEvents'
  | 'overflow';

export const getDirectThemeToBasePropertyCategories = (
  props: ThemeAllProps,
  include: {[key in Categories]?: boolean},
): ThemeDirectProps => {
  // Consider all properties required, to get type error if introducing a new property not extraced
  const allProps = props as Required<ThemeAllProps>;
  const {
    raised,
    direction,
    horizontal,
    vertical,
    flex,
    justify,
    align,
    centered,
    alignSelf,
    position,
    absolute,
    top,
    left,
    right,
    bottom,
    zIndex,
    visibility,
    hidden,
    pointerEvents,
    overflow,
  } = allProps;

  const allShadow: Required<ThemeShadowProps> | undefined = include.shadow
    ? {raised}
    : undefined;
  const allFlexDirection:
    | Required<ThemeFlexDirectionProps>
    | undefined = include.flexDirection
    ? {direction, horizontal, vertical}
    : undefined;
  const allFlex: Required<ThemeFlexProps> | undefined = include.flex
    ? {flex, justify, align, centered, alignSelf}
    : undefined;
  const allPosition: Required<ThemePositionProps> | undefined = include.position
    ? {position, absolute, top, left, right, bottom, zIndex}
    : undefined;
  const allVisibility:
    | Required<ThemeVisibilityProps>
    | undefined = include.visibility ? {visibility, hidden} : undefined;
  const allPointerEvents:
    | Required<ThemePointerEventsProps>
    | undefined = include.pointerEvents ? {pointerEvents} : undefined;
  const allOverflow: Required<ThemeOverflowProps> | undefined = include.overflow
    ? {overflow}
    : undefined;

  return {
    ...allShadow,
    ...allFlexDirection,
    ...allFlex,
    ...allPosition,
    ...allVisibility,
    ...allPointerEvents,
    ...allOverflow,
  };
};
